export default "__VITE_ASSET__CLjpHLkT__"